import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function sendStaffInvites(
  { salonId, emails, expiration, staffIds },
  token
) {
  const res = await axios.post(
    `${API}/staff-invites/send`,
    {
      salon_id: salonId,
      emails: Array.isArray(emails) ? emails : [],
      expiration,
      staff_ids: Array.isArray(staffIds) ? staffIds : [],
    },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getStaffInvite(tokenValue) {
  const res = await axios.get(`${API}/staff-invites/${tokenValue}`);
  return res.data;
}

export async function acceptStaffInvite(tokenValue, payload) {
  const res = await axios.post(
    `${API}/staff-invites/${tokenValue}/accept`,
    payload
  );
  return res.data;
}
